// The per-section title (e.g. "About me", "My Skills") that used to live in the
// old top Header. The nav icons now live in the SideNav, so this is just the
// heading text in the retro header font.
export default function SectionHeader({ title }) {
    return (
        <h1 className="section-header header text-5xl text-center px-4 pb-8">
            {title}
        </h1>
    )
}
